<template>
  <form method="post" :action="addToCartUrl" class="position-relative">
    <LoadingSpinner v-if="productStore.loading || peopleStore.loadingObject.loading" />

    <input type="hidden" name="ticket-id" value="rent-cart">

    <div class="position-relative">
      <div class="intersport-sidebox__header">
        <h4 class="intersport-sidebox__title">{{ translate('intersport.sidebox-title') }}</h4>
        <div class="intersport-sidebox__header-info font-bold">
          <span class="icon icon-poi"></span>
          <span class="intersport-sidebox__timespan-header-text">{{ locationText }}</span>
        </div>
        <div class="intersport-sidebox__header-info">
          <span class="icon icon-calendar"></span>
          <span class="intersport-sidebox__header-info-text">{{ dateString }}</span>
        </div>
      </div>

      <ul class="list-unstyled intersport-sidebox__people-list">
        <IntersportPerson v-for="person in people" :id="person.id" :birth-date="person.birthDate" :last-name="person.lastName" :first-name="person.firstName" :additional-data="person.additionalData" />
        <li class="intersport-sidebox__people-list-item">
          <button type="button" class="btn btn-nostyling btn-icon-text intersport-sidebox__add-person-btn"
                  data-bs-target="#intersport-person-modal"
                  @click="peopleStore.openModal()">
            <span class="icon icon-accordeon-open btn-icon-text__icon"></span>
            <span>{{ translate('intersport.sidebox-add-person') }}</span>
          </button>
        </li>
      </ul>

      <div class="intersport-sidebox__total-price-with-tag">
        <span class="intersport-sidebox__total-price-tag">{{ translate('intersport.sidebox-total-price-text') }}</span>
        <strong><Price :value="productStore.getSideboxTotalPrice()" /></strong>
      </div>
    </div>

    <div class="intersport-sidebox__footer">
      <button type="submit"
              class="btn btn-primary intersport-sidebox__button"
              :disabled="productStore.getSelectedAvailabilities().length === 0">
        <span class="icon icon-bag cart-sidebox__button-icon" aria-hidden="true"></span>
        {{ translate('intersport.sidebox-add-to-cart') }}
      </button>
    </div>
  </form>
</template>

<script setup lang="ts">
// @ts-ignore
import {defineProps, watch, computed, onMounted, onUpdated} from "vue";
// @ts-ignore
import { ISOStringToDate } from "@elements/date-utils";
// @ts-ignore
import {find, on} from "@elements/dom-utils";
// @ts-ignore
import {translate} from "@elements/translations";
// @ts-ignore
import { PeopleStore } from "../types/intersport.ts";
import LoadingSpinner from "./components/LoadingSpinner.vue";
import {useSearchStore} from "../stores/SearchStore.ts";
import {usePeopleStore} from "../stores/PeopleStore.ts";
import {useProductsStore} from "../stores/ProductStore.ts";
import * as affix from '../../scripts/elements-packages/affix';
import Price from "./components/Price.vue";
import IntersportPerson from "./components/IntersportPerson.vue";

const props = defineProps<{
  peopleJson: PeopleStore,
  peopleRequestUrl: string,
  profileRequestUrl?: string,
  availabilityRequestUrl: string,
  addToCartUrl: string
}>();

const searchStore = useSearchStore();
const peopleStore = usePeopleStore();
const productStore = useProductsStore();
let scrollTop = false;

peopleStore.fillStore(props.peopleJson);
peopleStore.setRequestUrl(props.peopleRequestUrl);
productStore.setAvailabilityRequestUrl(props.availabilityRequestUrl);

onMounted(() => {
  if (props.profileRequestUrl) {
    peopleStore.setProfileRequestUrl(props.profileRequestUrl);
  }

  affix.createAffix(find('.js-affix-sidebox'), {mediaQuery: '(min-width: 768px)'}, {
    base: '.js-affix-sidebox',
    placeholder: '.js-affix-sidebox__placeholder',
    container: '.js-affix-sidebox__container'
  });

  on('scroll', () => {
    if (scrollTop && document.body.scrollTop === 0 && document.documentElement.scrollTop === 0) {
      affix.createAffix(find('.js-affix-sidebox'), {mediaQuery: '(min-width: 768px)'}, {
        base: '.js-affix-sidebox',
        placeholder: '.js-affix-sidebox__placeholder',
        container: '.js-affix-sidebox__container'
      });
      scrollTop = false;
    }
  }, window)
});

onUpdated(() => {
  if (!productStore.loading || !peopleStore.loadingObject.loading) {
    let affixSidebox = find('.js-affix-sidebox');

    if (affixSidebox.getBoundingClientRect().height >= (window.innerHeight - find('.js-affix-nav').offsetHeight)) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      scrollTop = true;
    } else {
      affix.createAffix(affixSidebox, {mediaQuery: '(min-width: 768px)'}, {
        base: '.js-affix-sidebox',
        placeholder: '.js-affix-sidebox__placeholder',
        container: '.js-affix-sidebox__container'
      });
    }
  }
});

const people = computed(() => {
  return peopleStore.getPeopleInfo();
})

const locationText = computed(() => {
  const location = searchStore.selectedLocation;
  if (Object.keys(location).length > 0) {
    return location.label;
  }
  return translate('instersport.select-location-text');
})

const dateString = computed(() => {
  if (searchStore.startDate) {
    let endDate = searchStore.endDate ? ISOStringToDate(searchStore.endDate).toLocaleDateString() : translate('intersport.sidebox-pick-to-date')
    return `${ISOStringToDate(searchStore.startDate).toLocaleDateString()} - ${endDate}`;
  }
  return translate('instersport.select-date-range-text');
})

</script>